import { Component, Inject, ViewChild } from "@angular/core";
import { CommonModule, Location } from "@angular/common";
;
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder } from "@angular/forms";
import {  MAT_BOTTOM_SHEET_DATA, MatBottomSheet, MatBottomSheetModule, MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule, MatIconRegistry } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatToolbarModule } from "@angular/material/toolbar";

import { MatInputModule } from "@angular/material/input";
import { MatTable, MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatSortModule } from "@angular/material/sort";
import { MatTooltipModule } from "@angular/material/tooltip";


import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { Building, BuildingUnit, NetworkMember } from "huddyapi";
import moment from "moment";



@Component({
  selector: 'unit-log',
  standalone: true,
  templateUrl: 'unit-log.html',
  styleUrls: ['unit-log.scss'],
  providers: [

  ],
  imports : [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatCardModule,
    MatDialogModule,
    MatIconModule,
    MatListModule,
    MatToolbarModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSelectModule,
    MatSortModule,
    MatTooltipModule
  ]
})
export class UnitLog {



  building : Building  | undefined;
  @ViewChild(MatTable) table!: MatTable<any>;
  buildingCode!: number;
  displayColumns : string[] = [ 'identifier',  'status', 'reportedBy', 'reportedAt' ];



  constructor(
    private _bottomSheet: MatBottomSheetRef<UnitLog>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data : { building: Building},
    public router: Router,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private _location: Location,

  ) {


   
  }

  public ngOnDestroy() {



  }
  


  ngOnInit(): void {
    
   this.building = this.data.building;
    
  }


  getBuildingUnits() : BuildingUnit[]{
    let ret : BuildingUnit[] = [];
    if (this.building && this.building.units) {
      ret = this.building.units;
    }
    return ret;
  }

  formatFloorUnit(floorUnit: string) {
    return floorUnit.substring(0,2) + '-' + floorUnit.substring(2);
  }

  getColorFromName(name : string) : string {
    let ret : string = '#DAC7FD';
    
    if (name) {
      ret = NetworkMember.getColorForName(name);
      if (ret === 'avatarColor0') {
        ret = '#DAC7FD';
      } else if (ret === 'avatarColor1') {
        ret = '#F06D82';
      } else if (ret === 'avatarColor2') {
        ret = '#75C5EC';
      } else if (ret === 'avatarColor3') {
        ret = '#A7C2EF';
      }
    }
    return ret;
  }

  changeSort($event : any) {
    if (this.building) {
     let units : BuildingUnit[] | undefined = this.building?.units;
     if (units) {
          //'identifier',  'status', 'reportedBy', 'reportedAt'
        const sort = $event.active;
        const sortDir = $event.direction;
        if (sort === 'reportedAt') {
          units.sort((a: BuildingUnit, b: BuildingUnit) => {
              return a.reportedAt - b.reportedAt
          });
        } else {
          units.sort((a: BuildingUnit, b: BuildingUnit) => {
            const keyTypedA = sort as keyof typeof a;
            const keyTypedB = sort as keyof typeof a;
            const aValue : string =  a[keyTypedA] as string;
            const bValue : string =  b[keyTypedB] as string;
            return aValue.localeCompare(bValue);
          });
        }
        if (sortDir && sortDir === 'desc') {
          units = units.reverse();
        }
        this.building.units = units;
        this.table.renderRows();
     }
    }

  }

  resolveBuildingCode() : string {
    if (this.building) {
      return this.building.buildingCode;
    }
    return 'A';
  }

  getReportedAt(unixTime : number):string {
    return moment.unix(unixTime).format('MM/DD/YY h:mm a');
  }

  back() {
    this._location.back();
  }

}